<template>
    <div
        class="navigation_item vf-tooltip-toggle primary-link"
        :class="name"
    >
        <list-dropdown
            class="js-tooltip"
            :is-dropdown-open="isDropdownOpen"
            :items="links"
            :ul-properties="ulProperties"
            activate-on-hover
            @hide="hide"
            @dropdown-entered="toggleOnEnter"
        >
            <template #trigger>
                <button
                    class="head btn-link js-nav-main-item js-head-link vf-expanding-hover-light"
                    :class="activeClass"
                    :aria-controls="menuId"
                >
                    <span class="display-name truncate">{{ user.name }}</span>
                    <vf-cog-icon class="icon-cog" />
                </button>
            </template>
            <template
                v-for="item in links"
                #[item.key]
            >
                <button
                    v-if="isLogout(item)"
                    :key="item.key"
                    class="menu-link vf-dropdown-list__accent-hover-button"
                    :class="{'vf-active': item.isActive}"
                    @click="$emit('logout-clicked', item.href)"
                >
                    {{ getLinkText(item.name) }}
                </button>
                <a
                    v-else-if="item.href"
                    :key="item.key"
                    :href="item.href"
                    class="menu-link vf-dropdown-list__accent-hover-button"
                    :class="{'vf-active': item.isActive}"
                >
                    {{ getLinkText(item.name) }}
                </a>
                <button
                    v-else
                    :key="item.key"
                    disabled
                    class="btn-link menu-link vf-dropdown-list__accent-hover-button"
                    :class="{'vf-active': item.isActive}"
                >
                    {{ getLinkText(item.name) }}
                </button>
            </template>
        </list-dropdown>
    </div>
</template>

<script>
import { vfCogIcon } from 'design-assets/components/svg/icons/cog_icon.c.js';
import navItem from './nav-item.vue';
import ListDropdown from 'design-assets/components/dropdown/list-dropdown.vue';
import { NAVIGATION } from './constants/universal_header.js';
import VueTypes from 'commons/util/vue-types.js';

export default {
    extends: navItem,

    props: {
        links: VueTypes.array,
    },

    methods: {
        /**
         * The logout route needs to call 2 different logout endpoints :(
         * so it cannot work as a static link. Instead we emit events which the projects
         * using the UH can handle the special login route (DAD-845)
         * @param {any} { key } key denoting which menu item it is
         * @returns {Boolean} true if it is the logout link, false otherwise
         */
        isLogout({ key }) {
            return key === NAVIGATION.LOG_OUT;
        },
    },

    components: {
        vfCogIcon,
        ListDropdown,
    },
};
</script>
